<template>
  <div id="StudentMovementReport">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left">Student Movement Report</h3>
        </div>
      </div>
      <!--<div>-->
      <div class="tl-search-bar">
        <el-date-picker
          v-model="inputFromDate"
          type="daterange"
          range-separator="TO"
          start-placeholder="From Date"
          end-placeholder="To Date"
          format="dd/MM/yyyy"
          value-format="dd/MM/yyyy"
        >
        </el-date-picker>
        <el-button class="" v-on:click="Search()">Search </el-button>
      </div>
      <!--</div>-->

      <div>
        <div
          class="empty-list_image"
          v-if="
            StudentMovementEnrollmentListInt.length < 1 &&
            StudentMovementWithdrawalListInt.length < 1 &&
            StudentMovementGraduationListInt.length < 1 &&
            StudentMovementTransferInListInt.length < 1 &&
            StudentMovementTransferOutListInt.length < 1
          "
        >
          <img src="../assets/notfound.png" />
        </div>

        <div
          v-if="
            StudentMovementEnrollmentListInt.length > 0 ||
            StudentMovementWithdrawalListInt.length > 0 ||
            StudentMovementGraduationListInt.length > 0 ||
            StudentMovementTransferInListInt.length > 0 ||
            StudentMovementTransferOutListInt.length > 0
          "
          style="text-align: right"
        >
          <el-button size="small" type="primary" icon="el-icon-download" v-on:click="DownloadExcel()">Download </el-button>
        </div>

        <el-tabs
          v-model="activeReport"
          type="card"
          v-if="
            StudentMovementEnrollmentListInt.length > 0 ||
            StudentMovementWithdrawalListInt.length > 0 ||
            StudentMovementGraduationListInt.length > 0 ||
            StudentMovementTransferInListInt.length > 0 ||
            StudentMovementTransferOutListInt.length > 0
          "
          class="mt-3"
        >
          <el-tab-pane label="New Enrollment" name="New Enrollment">
            <div v-if="StudentMovementEnrollmentListInt.length > 0" class="datatable_group">
              <data-tables
                :data="StudentMovementEnrollmentListInt"
                :page-size="pageSize"
                :pagination-props="{ pageSizes: [pageSize, 100] }"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="StudentMovementEnrollmentListTable"
              >
                <el-table-column label="#" min-width="45px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in StudentMovementEnrollmentList"
                  min-width="150px"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="Class" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ClassName ? scope.row.ClassName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Course Name" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CourseName ? scope.row.CourseName : '-' }}</span>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Withdrawal" name="Withdrawal">
            <div v-if="StudentMovementWithdrawalListInt.length > 0" class="datatable_group">
              <!--<el-button size="small" type="primary" icon="el-icon-download" v-on:click="DownloadExcel()"-->
              <!--class="pull-right mb-3">Download-->
              <!--</el-button>-->
              <data-tables
                :data="StudentMovementWithdrawalListInt"
                :page-size="pageSize"
                :pagination-props="{ pageSizes: [pageSize, 100] }"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="StudentMovementWithdrawalListTable"
              >
                <el-table-column label="#" min-width="45px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in StudentMovementWithdrawalList"
                  min-width="150px"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="Class" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ClassName ? scope.row.ClassName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Course Name" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CourseName ? scope.row.CourseName : '-' }}</span>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Graduation" name="Graduation">
            <div v-if="StudentMovementGraduationListInt.length > 0" class="datatable_group">
              <data-tables
                :data="StudentMovementGraduationListInt"
                :page-size="pageSize"
                :pagination-props="{ pageSizes: [pageSize, 100] }"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="StudentMovementGraduationListTable"
              >
                <el-table-column label="#" min-width="45px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in StudentMovementGraduationList"
                  min-width="150px"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="Class" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ClassName ? scope.row.ClassName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Course Name" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CourseName ? scope.row.CourseName : '-' }}</span>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Transfer In" name="Transfer In">
            <div v-if="StudentMovementTransferInListInt.length > 0" class="datatable_group">
              <data-tables
                :data="StudentMovementTransferInListInt"
                :page-size="pageSize"
                :pagination-props="{ pageSizes: [pageSize, 100] }"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="StudentMovementTransferInListTable"
              >
                <el-table-column label="#" min-width="45px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in StudentMovementTransferInList"
                  min-width="150px"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="Class" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ClassName ? scope.row.ClassName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Course Name" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CourseName ? scope.row.CourseName : '-' }}</span>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>

          <el-tab-pane label="Transfer Out" name="Transfer Out">
            <div v-if="StudentMovementTransferOutListInt.length > 0" class="datatable_group">
              <data-tables
                :data="StudentMovementTransferOutListInt"
                :page-size="pageSize"
                :pagination-props="{ pageSizes: [pageSize, 100] }"
                width="55"
                stripe
                tooltip-effect="light"
                border
                ref="StudentMovementTransferOutListTable"
              >
                <el-table-column label="#" min-width="45px">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  v-for="item in StudentMovementTransferOutList"
                  min-width="150px"
                  :prop="item.prop"
                  :label="item.label"
                  :key="item.prop"
                  sortable="custom"
                >
                </el-table-column>
                <el-table-column label="Class" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ClassName ? scope.row.ClassName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="Course Name" :min-width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.CourseName ? scope.row.CourseName : '-' }}</span>
                  </template>
                </el-table-column>
              </data-tables>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import XLSX from 'xlsx'

export default {
  name: 'StudentMovementReport',
  async created() {},
  async mounted() {},

  data() {
    return {
      activeReport: 'New Enrollment',

      StudentMovementEnrollmentListInt: [],

      StudentMovementEnrollmentList: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'Full Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'Created_On_Convert',
          label: 'Registered Date',
        },
        {
          prop: 'Regst_date_Convert',
          label: 'Comm Date',
          // },{
          //     prop: "ClassName",
          //     label: "Class"
          // },{
          //     prop: "CourseName",
          //     label: "Course Name"
        },
      ],

      StudentMovementWithdrawalListInt: [],

      StudentMovementWithdrawalList: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'Full Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'GRD_CreatedOn_Convert',
          label: 'Received Date',
        },
        {
          prop: 'Withdrawal_Date_Convert',
          label: 'Effective Date',
          // },{
          //     prop: "ClassName",
          //     label: "Class"
          // },{
          //     prop: "CourseName",
          //     label: "Course Name"
        },
        {
          prop: 'GRD_Remarks',
          label: 'Reason',
        },
      ],

      StudentMovementGraduationListInt: [],

      StudentMovementGraduationList: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'Full Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'GRD_CreatedOn_Convert',
          label: 'Received Date',
        },
        {
          prop: 'Graduated_Date_Convert',
          label: 'Effective Date',
          // },{
          //     prop: "ClassName",
          //     label: "Class"
          // },{
          //     prop: "CourseName",
          //     label: "Course Name"
        },
      ],

      StudentMovementTransferInListInt: [],

      StudentMovementTransferInList: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'Full Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'STUSCH_Created_On_Convert',
          label: 'Received Date',
        },
        {
          prop: 'STUSCH_EffectiveDate_Convert',
          label: 'Effective Date',
          // },{
          //     prop: "ClassName",
          //     label: "Class"
          // },{
          //     prop: "CourseName",
          //     label: "Course Name"
        },
        {
          prop: 'fromSchool',
          label: 'From School',
        },
      ],

      StudentMovementTransferOutListInt: [],

      StudentMovementTransferOutList: [
        {
          prop: 'Index_No',
          label: 'Student No',
        },
        {
          prop: 'Full_Name',
          label: 'Full Name',
        },
        {
          prop: 'Middle_name',
          label: 'Middle Name',
        },
        {
          prop: 'Last_name',
          label: 'Last Name',
        },
        {
          prop: 'STUSCH_Created_On_Convert',
          label: 'Received Date',
        },
        {
          prop: 'STUSCH_EffectiveDate_Convert',
          label: 'Effective Date',
          // },{
          //     prop: "ClassName",
          //     label: "Class"
          // },{
          //     prop: "CourseName",
          //     label: "Course Name"
        },
        {
          prop: 'toSchool',
          label: 'To School',
        },
      ],

      pageSize: 50,
      inputFromDate: [],
    }
  },
  methods: {
    async Search() {
      try {
        if (this.inputFromDate.length < 1) {
          this.$notify({
            title: 'Require',
            message: '"Please select date"',
          })
        } else {
          this.$vs.loading()

          const enrollmentResponse = await DataSource.shared.getStudentMovementReport('enrollment', this.inputFromDate[0], this.inputFromDate[1])
          if (enrollmentResponse) {
            if (enrollmentResponse.code === '88') {
              window.location.replace('/')
            } else if (enrollmentResponse.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (enrollmentResponse.code === '2') {
              // this.$notify({
              //     title: 'No Record',
              //     message: 'No Record Found'
              //
              // });
              this.StudentMovementEnrollmentListInt = []
            } else {
              this.StudentMovementEnrollmentListInt = enrollmentResponse.Table
            }
          }
          const withdrawalResponse = await DataSource.shared.getStudentMovementReport('withdrawal', this.inputFromDate[0], this.inputFromDate[1])
          if (withdrawalResponse) {
            if (withdrawalResponse.code === '88') {
              window.location.replace('/')
            } else if (withdrawalResponse.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (withdrawalResponse.code === '2') {
              // this.$notify({
              //     title: 'No Record',
              //     message: 'No Record Found'
              // });
              this.StudentMovementWithdrawalListInt = []
            } else {
              this.StudentMovementWithdrawalListInt = withdrawalResponse.Table
            }
          }

          const graduationResponse = await DataSource.shared.getStudentMovementReport('graduation', this.inputFromDate[0], this.inputFromDate[1])
          if (graduationResponse) {
            if (graduationResponse.code === '88') {
              window.location.replace('/')
            } else if (graduationResponse.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (graduationResponse.code === '2') {
              // this.$notify({
              //     title: 'No Record',
              //     message: 'No Record Found'
              // });
              this.StudentMovementGraduationListInt = []
            } else {
              this.StudentMovementGraduationListInt = graduationResponse.Table
            }
          }

          const transferinResponse = await DataSource.shared.getStudentMovementReport('transferin', this.inputFromDate[0], this.inputFromDate[1])
          if (transferinResponse) {
            if (transferinResponse.code === '88') {
              window.location.replace('/')
            } else if (transferinResponse.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (transferinResponse.code === '2') {
              // this.$notify({
              //     title: 'No Record',
              //     message: 'No Record Found'
              // });
              this.StudentMovementTransferInListInt = []
            } else {
              this.StudentMovementTransferInListInt = transferinResponse.Table
            }
          }

          const transferoutResponse = await DataSource.shared.getStudentMovementReport('transferout', this.inputFromDate[0], this.inputFromDate[1])
          if (transferoutResponse) {
            if (transferoutResponse.code === '88') {
              window.location.replace('/')
            } else if (transferoutResponse.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (transferoutResponse.code === '2') {
              // this.$notify({
              //     title: 'No Record',
              //     message: 'No Record Found'
              // });
              this.StudentMovementTransferOutListInt = []
            } else {
              this.StudentMovementTransferOutListInt = transferoutResponse.Table
            }
          }

          if (
            enrollmentResponse.code === '2' &&
            withdrawalResponse.code === '2' &&
            graduationResponse.code === '2' &&
            transferinResponse.code === '2' &&
            transferoutResponse.code === '2'
          ) {
            this.$notify({
              title: 'No Record',
              message: 'No Record Found',
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    DownloadExcel() {
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      let exportNewEnrollmentExcelObject = []
      let exportWithdrawalExcelObject = []
      let exportGraduateExcelObject = []
      let exportTransferInExcelObject = []
      let exportTransferOutExcelObject = []

      this.StudentMovementEnrollmentListInt.forEach(m => {
        let tempEnrollmentList = {
          'Student No': m.Index_No,
          'Full Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Registered Date': m.Created_On_Convert,
          'Comm Date': m.Regst_date_Convert,
          Class: m.ClassName ? m.ClassName : '-',
          'Course Name': m.CourseName ? m.CourseName : '-',
        }
        exportNewEnrollmentExcelObject.push(tempEnrollmentList)
      })

      this.StudentMovementWithdrawalListInt.forEach(m => {
        let tempWithdrawalList = {
          'Student No': m.Index_No,
          'Full Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Received Date': m.GRD_CreatedOn_Convert,
          'Effective Date': m.Withdrawal_Date_Convert,
          Class: m.ClassName ? m.ClassName : '-',
          'Course Name': m.CourseName ? m.CourseName : '-',
          Reason: m.GRD_Remarks,
        }
        exportWithdrawalExcelObject.push(tempWithdrawalList)
      })

      this.StudentMovementGraduationListInt.forEach(m => {
        let tempGraduateList = {
          'Student No': m.Index_No,
          'Full Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Received Date': m.GRD_CreatedOn_Convert,
          'Effective Date': m.Graduated_Date_Convert,
          Class: m.ClassName ? m.ClassName : '-',
          'Course Name': m.CourseName ? m.CourseName : '-',
        }
        exportGraduateExcelObject.push(tempGraduateList)
      })

      this.StudentMovementTransferInListInt.forEach(m => {
        let tempTransferInList = {
          'Student No': m.Index_No,
          'Full Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Received Date': m.STUSCH_Created_On_Convert,
          'Effective Date': m.STUSCH_EffectiveDate_Convert,
          Class: m.ClassName ? m.ClassName : '-',
          'Course Name': m.CourseName ? m.CourseName : '-',
          'From School': m.fromSchool,
        }
        exportTransferInExcelObject.push(tempTransferInList)
      })

      this.StudentMovementTransferOutListInt.forEach(m => {
        let tempTransferOutList = {
          'Student No': m.Index_No,
          'Full Name': m.Full_Name,
          'Middle Name': m.Middle_name,
          'Last Name': m.Last_name,
          'Received Date': m.STUSCH_Created_On_Convert,
          'Effective Date': m.STUSCH_EffectiveDate_Convert,
          Class: m.ClassName ? m.ClassName : '-',
          'Course Name': m.CourseName ? m.CourseName : '-',
          'To School': m.toSchool,
        }
        exportTransferOutExcelObject.push(tempTransferOutList)
      })

      var sheetNewEnrollment = XLSX.utils.json_to_sheet(exportNewEnrollmentExcelObject)
      var sheetWithdrawal = XLSX.utils.json_to_sheet(exportWithdrawalExcelObject)
      var sheetGraduated = XLSX.utils.json_to_sheet(exportGraduateExcelObject)
      var sheetTransferIn = XLSX.utils.json_to_sheet(exportTransferInExcelObject)
      var sheetTransferOut = XLSX.utils.json_to_sheet(exportTransferOutExcelObject)

      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, sheetNewEnrollment, 'New Enrollment') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheetWithdrawal, 'Withdrawal') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheetGraduated, 'Graduated') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheetTransferIn, 'Transfer In') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, sheetTransferOut, 'Transfer Out') // sheetAName is name of Worksheet
      XLSX.writeFile(wb, 'Student Movement Report - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>

<style scoped>
.tl-search-bar button {
  background: #007bff !important;
  color: white;
  border: 0px;
}
</style>
